import { Button, colors } from "@mui/material";
import React, {useState} from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router";
import { BrowserRouter as Router, Route, Link, useHistory } from 'react-router-dom';

function Sidebar() {
  const [activeItem, setActiveItem] = useState(null);
  const [route, setRoute] = useState("");

  const navigate = useNavigate();

  const handleItemClick = (item) => {
    setRoute("/"+item);
    navigate(route);
    setActiveItem(item);
  };

  const navItems = [
    { id: 'index', label: 'Home' },
    { id: 'buy', label: 'Buy' },
    { id: 'sell', label: 'Sell' },
    { id: 'history', label: 'History' },
    // { id: 'reports', label: 'Reports' },
    // { id: 'orders', label: 'My Orders' },
    // { id: 'services', label: 'Customer Service' },
    // { id: 'about', label: 'About' },
  ];

  return (
    <div className="sidebar-wrapper">
      <div className="sidebar">
        {/* <Button>
          <CloseIcon sx={{color:"rgb(179, 179, 0)"}} />
        </Button> */}
        <ul>
          <li>
            <a
              href="#"
              className={`nav-item ${activeItem === "index" ? 'active' : ''}`}
              onClick={() => navigate("/index")}
            >
              Dashboard
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-item ${activeItem === "index" ? 'active' : ''}`}
              onClick={() => navigate("/buy")}
            >
              Buy
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-item ${activeItem === "index" ? 'active' : ''}`}
              onClick={() => navigate("/sell")}
            >
              Sell
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-item ${activeItem === "index" ? 'active' : ''}`}
              onClick={() => navigate("/history")}
            >
              Transactions
            </a>
          </li>
          <li>
            <a
              href="#"
              className={`nav-item ${activeItem === "index" ? 'active' : ''}`}
              onClick={() => navigate("/")}
            >
              Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;